module.exports = __webpack_public_path__ + "img/icon-wxpay.29058df4.svg";